import { createContext } from 'react';

const PaymentContext = createContext({
  session: '',
  setSession: (sess) => {},
});

export { PaymentContext };
